// CON-2524 - Remove entire folder if Coverage needs loses
import React from 'react';
import { Route, Routes } from 'react-router-dom';

import {
  COVERAGE_NEEDS_START_PATH,
  COVERAGE_NEEDS_INCOME_PATH,
  COVERAGE_NEEDS_OBLIGATIONS_PATH,
  COVERAGE_NEEDS_SAVINGS_PATH,
  COVERAGE_NEEDS_PARTNER_PATH,
  COVERAGE_NEEDS_CHILDREN_PATH,
  COVERAGE_NEEDS_CALCULATING_PATH,
  COVERAGE_NEEDS_RECOMMENDATION_PATH,
} from '../constants';
import {
  CoverageNeedsStart,
  CoverageNeedsCalculating,
  CoverageNeedsChildren,
  CoverageNeedsPartner,
  CoverageNeedsIncome,
  CoverageNeedsRecommendation,
  CoverageNeedsObligations,
  CoverageNeedsSavings,
} from './lazyLoadableComponents';

const CoverageNeedsRoutes = () => (
  <Routes>
    <Route path={COVERAGE_NEEDS_START_PATH} element={<CoverageNeedsStart />} />
    <Route path={COVERAGE_NEEDS_CHILDREN_PATH} element={<CoverageNeedsChildren />} />
    <Route path={COVERAGE_NEEDS_PARTNER_PATH} element={<CoverageNeedsPartner />} />
    <Route path={COVERAGE_NEEDS_INCOME_PATH} element={<CoverageNeedsIncome />} />
    <Route path={COVERAGE_NEEDS_OBLIGATIONS_PATH} element={<CoverageNeedsObligations />} />
    <Route path={COVERAGE_NEEDS_SAVINGS_PATH} element={<CoverageNeedsSavings />} />
    <Route path={COVERAGE_NEEDS_CALCULATING_PATH} element={<CoverageNeedsCalculating />} />
    <Route path={COVERAGE_NEEDS_RECOMMENDATION_PATH} element={<CoverageNeedsRecommendation />} />
  </Routes>
);

export default CoverageNeedsRoutes;
